import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Keyword } from "../../types"
import { initialValuesKeyword, validationSchemaKeyword } from "./KeywordCommon"
import { useDeleteKeyword, useKeyword, useUpdateKeyword } from "../../hooks/keywords"
import KeywordForm from "./KeywordForm"

export default function KeywordUpdate() {
  const updateKeyword = useUpdateKeyword()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: keyword } = useKeyword(Number(id))

  const deleteKeyword = useDeleteKeyword()

  const [modalStateDeleteKeyword, modalActionsDeleteKeyword] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesKeyword(keyword), [keyword])
  const validationSchema = useMemo(() => validationSchemaKeyword(), [])

  useBreadcrumbs([{ label: "Keywords", href: "/keywords/keywords" }, { label: "Dettaglio Keywords" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{keyword?.name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteKeyword.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateKeyword.mutateAsync(values as Keyword).then(() => {
                navigate(`/keywords/keywords`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <KeywordForm />
                </Container>
                <BottomFormFixed url="/keywords/keywords" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteKeyword.isOpen}
        onClose={modalActionsDeleteKeyword.close}
        onDelete={() => {
          return deleteKeyword.mutateAsync(keyword?.id).then(() => {
            navigate(`/keywords/keywords`)
          })
        }}
        message="Sei sicuro di voler eliminare questa keyword?"
        title="Elimina Keyword"
      />
    </Layout>
  )
}
